module.exports = __webpack_public_path__ + "static/media/baby-emoji-svgrepo-com.6e7e380c.svg";